var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26324 3.01367H3.76324C3.34903 3.01367 3.01324 3.34946 3.01324 3.76367V8.26367C3.01324 8.67789 3.34903 9.01367 3.76324 9.01367H3.94337C3.96341 9.01173 3.98372 9.01074 4.00427 9.01074C4.34945 9.01074 4.62927 9.29056 4.62927 9.63574C4.62927 9.98092 4.34945 10.2607 4.00427 10.2607L4 10.2607V10.2637H3.76324C2.65868 10.2637 1.76324 9.36824 1.76324 8.26367V3.76367C1.76324 2.6591 2.65868 1.76367 3.76324 1.76367H8.26324C9.36781 1.76367 10.2632 2.6591 10.2632 3.76367V4H10.2619C10.2511 4.33569 9.97552 4.60449 9.63721 4.60449C9.29203 4.60449 9.01221 4.32467 9.01221 3.97949C9.01221 3.9673 9.01256 3.95519 9.01324 3.94317V3.76367C9.01324 3.34946 8.67746 3.01367 8.26324 3.01367Z",
    fill: "#040517",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75433 7.74725C5.75433 6.64268 6.64976 5.74725 7.75433 5.74725H12.2543C13.3589 5.74725 14.2543 6.64268 14.2543 7.74725V12.2472C14.2543 13.3518 13.3589 14.2472 12.2543 14.2472H7.75433C6.64976 14.2472 5.75433 13.3518 5.75433 12.2472V7.74725ZM7.75433 6.99725H12.2543C12.6685 6.99725 13.0043 7.33303 13.0043 7.74725V12.2472C13.0043 12.6615 12.6685 12.9972 12.2543 12.9972H7.75433C7.34012 12.9972 7.00433 12.6615 7.00433 12.2472V7.74725C7.00433 7.33303 7.34012 6.99725 7.75433 6.99725Z",
    fill: "#040517",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ebb388f89d3a7b70bdfb525acdb2094e.svg";
export { ForwardRef as ReactComponent };